var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapesArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6.375H15.125C15.4702 6.375 15.75 6.65482 15.75 7C15.75 7.34518 15.4702 7.625 15.125 7.625H8.50888L17.4419 16.5581C17.686 16.8021 17.686 17.1979 17.4419 17.4419C17.1979 17.686 16.8021 17.686 16.5581 17.4419L7.625 8.50888V15.125C7.625 15.4702 7.34518 15.75 7 15.75C6.65482 15.75 6.375 15.4702 6.375 15.125V7C6.375 6.65482 6.65482 6.375 7 6.375Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapesArrow);
export default __webpack_public_path__ + "static/media/shapes-arrow.4b69a2a1617a8ed3c818f7102a64d540.svg";
export { ForwardRef as ReactComponent };